export const environment = {
    version: '1.1.1 test',
    production: false,
    securityServerAddress: 'https://securityapp.test.brother.de/api',
    serverAddress: 'https://partnerapp.test.brother.de/api/v1',  // v1 should not be required here, but is not full tested yet. However, all or most of the services already ignore all after /api
    baseUrl: 'https://partnerapp.test.brother.de/',
    itScopeServerAddress: 'https://api.itscope.com/2.1',

    baseAuthCredentials: {
        username: 'bwoZlqSoWUHM',
        password: '24!whom!VALUE!island!37',
    },

    enableConsoleLog: true,

    headerStyles: {
        color: '#567398',
        backgroundColor: '#F8AF00',
        logoFilter: 'invert(1) brightness(0) saturate(100%) invert(45%) sepia(9%) saturate(1762%) hue-rotate(174deg) brightness(94%) contrast(91%)'
    }

};
